<div class="simmer-list">
    <div *ngFor="let item of [].constructor(count)" class="simmer-item">
      <!-- <div class="simmer-avatar"></div> -->
      <div class="simmer-content">
        <div class="simmer-line shimmer-animation"></div>
        <div class="simmer-line short shimmer-animation"></div>
      </div>
    </div>
  </div>
  